import ContentfulEntryCard from './component'
import ContentEntryDataGetter from 'layers/content/Hocs/ContentEntryDataGetter'
import PropTypes from 'prop-types'

export const ContentfulEntryCardContainer = ({ contentfulEntry }) => {
  return <ContentfulEntryCard contentfulEntry={contentfulEntry} />
}

export const mapper = entry => {
  return { contentfulEntry: entry }
}

const options = {
  include: 2,
  mapper,
  spread: true,
  entryIdProp: true,
}

ContentfulEntryCardContainer.propTypes = {
  contentfulEntry: PropTypes.shape({
    displayTitle: PropTypes.string,
    bodyCopy: PropTypes.string,
  }),
}

export default ContentEntryDataGetter(ContentfulEntryCardContainer, options)
